/**
 * Created by Mikhail Menshenin on 23.06.2025
 */

const RiddlesLevelMasteryWindowComponent = cc.Node.extend({
    ctor: function (levelMastery, styles) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.levelMastery = levelMastery;
        this.styles = styles || cleverapps.styles.RiddlesLevelMasteryWindowComponent;

        this.createProgressBar();
        cleverapps.UI.wrap(this);
        this.createCupIcon();
        this.createRewardIcon();
        cleverapps.UI.wrap(this);

        this.levelMastery.on("updateStage", this.updateStage.bind(this), this);
        this.levelMastery.on("updateLevel", this.updateLevel.bind(this), this);
    },

    createProgressBar: function () {
        this.progressBar = new ScaledProgressBar(this.styles.progressBar);
        this.progressBar.setLength(this.styles.progressBar.width, true);
        this.progressBar.setGoal(this.levelMastery.getCurrentStage().goal);
        this.progressBar.setPercentage(this.levelMastery.level);
        this.addChild(this.progressBar);
    },

    createCupIcon: function () {
        this.cupIcon = new cc.Sprite(bundles.levelmastery.frames.cup);
        this.cupIcon.setAlignment(this.styles.cupIcon);
        this.addChild(this.cupIcon);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(this.cupIcon, () => {}, {
                onDoubleClick: () => {
                    const missionLogic = cleverapps.missionManager.findRunningMission(Mission.TYPE_LEVEL_MASTERY).logic;
                    const remainingPoints = missionLogic.getCurrentStage().goal - missionLogic.level;
                    if (!remainingPoints) {
                        return;
                    }
                    missionLogic.incLevel(remainingPoints);
                },
                interactiveScale: false
            });
        }
    },

    createRewardIcon: function () {
        this.rewardIcon && this.rewardIcon.removeFromParent();
        this.rewardIcon = new RiddlesLevelMasteryRewardView(this.levelMastery.getCurrentReward(), {
            font: cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_WINDOW_PRIZE_TEXT
        });
        this.rewardIcon.setAlignment(this.styles.reward);
        this.addChild(this.rewardIcon);
    },

    updateStage: function (silent) {
        this.progressBar.setGoal(this.levelMastery.getCurrentStage().goal);
        this.progressBar.setPercentage(this.levelMastery.level);
        this.createRewardIcon();

        if (!silent) {
            this.rewardIcon.setVisible(false);
        }
    },

    updateLevel: function () {
        this.progressBar.setPercentage(this.levelMastery.level, {
            animated: true
        });
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_LEVELMASTERY_WINDOW_PROGRESSBAR_TEXT: {
        name: "default",
        size: 30
    },
    RIDDLES_LEVELMASTERY_WINDOW_PRIZE_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    }
});

cleverapps.styles.RiddlesLevelMasteryWindowComponent = {
    progressBar: {
        type: ScaledProgressBar.Types.green_large,
        width: 630,
        scale: 1,
        progress: bundles.levelmastery_window.frames.progress_bar_progress_png,
        background: bundles.levelmastery_window.frames.progress_bar_bg_png,
        barText: {
            dy: 0,
            font: cleverapps.styles.FONTS.RIDDLES_LEVELMASTERY_WINDOW_PROGRESSBAR_TEXT
        }
    },

    cupIcon: {
        x: { align: "left", dx: -40 },
        y: { align: "center" }
    },

    reward: {
        x: { align: "right", dx: 40 },
        y: { align: "center" }
    }
};
